import React, { useEffect } from 'react'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRegistro } from 'hooks/useLogin'
import { useHistory } from 'react-router-dom';
import './style.sass'

import { Header } from 'pages/Header'
import ErrorType from 'pages/Error/ErrorType'

import RegistroForm from 'components/LoginRegistro/Registro'
import Loading from 'components/Loading'
import { ErrorBoundary } from 'components/Error/ErrorBoundary'


export default function Registro() {
    const history = useHistory()

    //- Codigo de instana para track de pagina 
    // useEffect(() => {
    //     window.ineum('page', 'Register Page');
    //     window.scrollTo(0, 0);
    // }, [])

    const backHistory = () => {
        history.go(-1)
    }

    const {
        dataRegistro,
        reciveDataRegistro,
        reciveDataRegistroFacebook
    } = useRegistro()

    const { isMobile } = useIsMobile()
    const desktopView = () => document.querySelector('#root').classList.add('desktopView')

    useEffect(() => {
        if (isMobile) {
            if (isMobile === 'desktop') {
                document.querySelector('#root').classList.add('desktopView')
            }
        }
    }, [isMobile])


    return (
        <>
            { dataRegistro.loading && <Loading />}
            <Header type='simple' pageClass={isMobile !== 'desktop' ? "hidden" : "registroHeader"} />
            <main>
                {dataRegistro.statusCode !== 500
                    ?
                        <>
                            {!dataRegistro.isLoged &&
                                <section className="loginRegistroPage">
                                    <div className="container">
                                        {isMobile === 'desktop'
                                            ?
                                                <h1 className="titleRegistro">Crear cuenta</h1>
                                            :
                                                <div className="sectionTitleServicioCliente">
                                                    <button onClick={backHistory}>Crear cuenta</button>
                                                </div>
                                        }
                                        <ErrorBoundary>
                                            <RegistroForm
                                                dataForm={reciveDataRegistro}
                                                warningMessage={dataRegistro.errorMessage}
                                                urlRedirect={dataRegistro.redir}
                                                responseFacebook={reciveDataRegistroFacebook}
                                                isMobile={isMobile}
                                            />
                                        </ErrorBoundary>
                                    </div>
                                </section>
                            }
                        </>
                    :
                        <>
                            <ErrorBoundary>
                                <ErrorType
                                    codeStatus={500}
                                    errorText={""}
                                />
                            </ErrorBoundary>
                        </>
                }
            </main>
        </>
    )
}